var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.chain)?_c('div',{staticClass:"mb-1"},[_c('span',[_vm._v("Connected to Network: ")]),_c('span',{staticClass:"badge badge-info small"},[_vm._v(_vm._s(_vm.chain.name)+" ["+_vm._s(_vm.chain.chainId)+"]")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }